export default "__VITE_ASSET__BWtfRlbn__"